import { render } from "./MaterialAlertWatchList.vue?vue&type=template&id=d7be1b64"
import script from "./MaterialAlertWatchList.vue?vue&type=script&lang=js"
export * from "./MaterialAlertWatchList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__